import { languageGlobal } from "./GlobalVariableConfig";

export const getManifest = () => {
    return {
        bundles: [
            {
                name: 'intro-screen',
                assets: [
                    {
                        alias: 'volatilityBase',
                        src: 'assets/desktop/2_intro/volatility_base.webp',
                    },
                    {
                        alias: 'volatilityOn',
                        src: 'assets/desktop/2_intro/volatility_on.webp',
                    },
                    {
                        alias: 'volatilityOff',
                        src: 'assets/desktop/2_intro/volatility_off.webp',
                    },
                    {
                        alias: 'intro_bg',
                        src: 'assets/desktop/2_intro/intro_bg.webp',
                    },
                    {
                        alias: 'textBase',
                        src: 'assets/desktop/2_intro/ticket.webp',
                    },
                    {
                        alias: 'image1',
                        src: 'assets/desktop/2_intro/image_1.png',
                    },
                    {
                        alias: 'image2',
                        src: 'assets/desktop/2_intro/image_2.png',
                    },
                    {
                        alias: 'image3',
                        src: 'assets/desktop/2_intro/image_3.png',
                    },
                    {
                        alias: 'introLogoSprite',
                        src: 'assets/desktop/2_intro/logo.webp',
                    },
                    // Ticket Animation
                    {
                        alias: 'introTicketBaseSkel',
                        src: 'assets/desktop/2_intro/frame/frame.skel',
                    },
                    {
                        alias: 'introTicketBaseAtlas',
                        src: 'assets/desktop/2_intro/frame/frame.atlas',
                    },
                    // Image 1
                    {
                        alias: 'introImage1Skel',
                        src: 'assets/desktop/2_intro/wild_ticket/wild_ticket.skel',
                    },
                    {
                        alias: 'introImage1Atlas',
                        src: 'assets/desktop/2_intro/wild_ticket/wild_ticket.atlas',
                    },
                    //Image 2
                    {
                        alias: 'introImage2Skel',
                        src: 'assets/desktop/2_intro/scatter_ticket/scatter_ticket.skel',
                    },
                    {
                        alias: 'introImage2Atlas',
                        src: 'assets/desktop/2_intro/scatter_ticket/scatter_ticket.atlas',
                    },
                    //Image 2
                    {
                        alias: 'introImage3Skel',
                        src: 'assets/desktop/2_intro/max_win_ticket/max_win_ticket.skel',
                    },
                    {
                        alias: 'introImage3Atlas',
                        src: 'assets/desktop/2_intro/max_win_ticket/max_win_ticket.atlas',
                    },
                    // {
                    //     alias: 'continueBase',
                    //     src: './2_intro/click_base.webp',
                    // },
                    // {
                    //     alias: 'introAppearSound',
                    //     src: 'assets/desktop/13_sound/gameloading/Intro_appear.mp3',
                    // },
                    {
                        alias: 'loading_bg',
                        src: 'assets/desktop/1_loading/loading_bg.webp',
                    },
                ]
            },
            {
                name: 'big-win',
                assets: [
                    {
                        alias: 'bigWinSkel',
                        src: languageGlobal === 'es-es' ? 'assets/desktop/9_bigwin/es/wins.skel' : 'assets/desktop/9_bigwin/wins.skel',
                    },
                    {
                        alias: 'bigWinAtlas',
                        src: languageGlobal === 'es-es' ? 'assets/desktop/9_bigwin/es/wins.atlas' : 'assets/desktop/9_bigwin/wins.atlas',
                    },
                    // {
                    //     alias: 'amount_base',
                    //     src: 'assets/desktop/bigwin/win_amount_base.webp',
                    // },
                ]
            },
            {
                name: 'game-screen',
                assets: [
                    {
                        alias: 'background',
                        src: 'assets/desktop/6_basegame/basegame.webp',
                    },
                    {
                        alias: 'backgroundFree',
                        src: 'assets/desktop/8_freegame/freegame.webp',
                    },
                    // reels back
                    {
                        alias: 'reelBackBase',
                        src: 'assets/desktop/10_reel/basegame_reel/reel.webp',
                    },
                    {
                        alias: 'reelBackleft',
                        src: 'assets/desktop/10_reel/basegame_reel/l_reel.webp',
                    },
                    {
                        alias: 'reelBackMid',
                        src: 'assets/desktop/10_reel/basegame_reel/m_reel.webp',
                    },
                    {
                        alias: 'reelBackRight',
                        src: 'assets/desktop/10_reel/basegame_reel/r_reel.webp',
                    },
                    {
                        alias: 'reelBackFree',
                        src: 'assets/desktop/10_reel/basegame_reel/reel.webp',
                    },
                    {
                        alias: 'grid',
                        src: 'assets/desktop/10_reel/grid.webp',
                    },
                    {
                        alias: 'baseGameGrid',
                        src: 'assets/desktop/10_reel/baseGameGrid.png',
                    },
                    // character animation *********************
                    // {
                    //     alias: 'characterSkel',
                    //     src: 'assets/desktop/5_character/mascot.skel',
                    // },
                    // {
                    //     alias: 'characterAtlas',
                    //     src: 'assets/desktop/5_character/mascot.atlas',
                    // },
                    // Game Intro animation *********************
                    {
                        alias: 'gameIntroSkel',
                        src: 'assets/desktop/3_game_intro/game_intro.skel',
                    },
                    {
                        alias: 'gameIntroAtlas',
                        src: 'assets/desktop/3_game_intro/game_intro.atlas',
                    },
                    //logo *********************
                    // {
                    //     alias: 'logoStatic',
                    //     src: 'assets/desktop/base/logo.webp',
                    // },
                    //Intro outro banner
                    // {
                    //     alias: 'introOutroAtlas',
                    //     src: 'assets/desktop/7_banner/intro_outro.atlas',
                    // },
                    // {
                    //     alias: 'introOutroSkel',
                    //     src: 'assets/desktop/7_banner/intro_outro.skel',
                    // },
                    // Banner Components
                    {
                        alias: 'bannerDrillAtlas',
                        src: 'assets/desktop/7_banner/intro_outro_drill/intro_outro_drill.atlas',
                    },
                    {
                        alias: 'bannerDrillSkel',
                        src: 'assets/desktop/7_banner/intro_outro_drill/intro_outro_drill.skel',
                    },
                    {
                        alias: 'bannerFrameAtlas',
                        src: 'assets/desktop/7_banner/intro_outro_frame/intro_outro.atlas',
                    },
                    {
                        alias: 'bannerFrameSkel',
                        src: 'assets/desktop/7_banner/intro_outro_frame/intro_outro.skel',
                    },
                    {
                        alias: 'bannerCharAtlas',
                        src: 'assets/desktop/7_banner/intro_outro_character/intro_outro_character.atlas',
                    },
                    {
                        alias: 'bannerCharSkel',
                        src: 'assets/desktop/7_banner/intro_outro_character/intro_outro_character.skel',
                    },
                    // //logo animation *********************
                    {
                        alias: 'logoSkel',
                        src: 'assets/desktop/4_logo/logo.skel',
                    },
                    {
                        alias: 'logoAtlas',
                        src: 'assets/desktop/4_logo/logo.atlas',
                    },
                    // multiplier meter *********************
                    // {
                    //     alias: 'multiplerMeterSkel',
                    //     src: 'assets/desktop/base/multiplier_meter/multiplier_meter.skel',
                    // },
                    // {
                    //     alias: 'multiplerMeterAtlas',
                    //     src: 'assets/desktop/base/multiplier_meter/multiplier_meter.atlas',
                    // },
                    {
                        alias: 'spinLeftSkel',
                        src: 'assets/desktop/14_feature/meter/meter.skel',
                    },
                    {
                        alias: 'spinLeftAtlas',
                        src: 'assets/desktop/14_feature/meter/meter.atlas',
                    },
                    // win collector meter
                    {
                        alias: 'winCollectMeterSkel',
                        src: 'assets/desktop/14_feature/winCollecter_meter/digital_pannel.skel',
                    },
                    {
                        alias: 'winCollectMeterAtlas',
                        src: 'assets/desktop/14_feature/winCollecter_meter/digital_pannel.atlas',
                    },
                    //banner *********************
                    // {
                    //     alias: 'banner',
                    //     src: 'assets/desktop/7_banner/intro_outro_base.webp',
                    // },
                    //banner
                    {
                        alias: 'freegame_intro_bg',
                        src: 'assets/desktop/7_banner/intro_outro_bg.webp',
                    },
                    {
                        alias: 'banner_mid_static',
                        src: 'assets/desktop/7_banner/banner_mid_static.webp'
                    },
                    //banner-left-char
                    {
                        alias: 'bannerCharLeftSkel',
                        src: 'assets/desktop/7_banner/L/intro_rat.skel',
                    },
                    {
                        alias: 'bannerCharLeftAtlas',
                        src: 'assets/desktop/7_banner/L/intro_rat.atlas',
                    },
                    //banner-right-char
                    {
                        alias: 'bannerCharRightSkel',
                        src: 'assets/desktop/7_banner/R/intro_cat.skel',
                    },
                    {
                        alias: 'bannerCharRightAtlas',
                        src: 'assets/desktop/7_banner/R/intro_cat.atlas',
                    },
                    //base game background animation
                    {
                        alias: 'base_track',
                        src: 'assets/desktop/6_basegame/track.webp',
                    },
                    {
                        alias: 'baseBackgroundSkel',
                        src: 'assets/desktop/6_basegame/baseBgAnimation/basegame.skel',
                    },
                    {
                        alias: 'baseBackgroundAtlas',
                        src: 'assets/desktop/6_basegame/baseBgAnimation/basegame.atlas',
                    },

                    //free game background animation
                    {
                        alias: 'free_track',
                        src: 'assets/desktop/8_freegame/freegame_track.webp',
                    },
                    {
                        alias: 'freeBackgroundSkel',
                        src: 'assets/desktop/8_freegame/freeBgAnimation/freegame.skel',
                    },
                    {
                        alias: 'freeBackgroundAtlas',
                        src: 'assets/desktop/8_freegame/freeBgAnimation/freegame.atlas',
                    },

                    //free game transition
                    // {
                    //     alias: 'transitionSkel',
                    //     src: 'assets/desktop/base/transition/transition.skel',
                    // },
                    // {
                    //     alias: 'transitionAtlas',
                    //     src: 'assets/desktop/base/transition/transition.atlas',
                    // },
                    // hold and spin transition
                    {
                        alias: 'holdAndSpinTransitionSkel',
                        src: 'assets/desktop/14_feature/scene_change_transition/transition_blast.skel',
                    },
                    {
                        alias: 'holdAndSpinTransitionAtlas',
                        src: 'assets/desktop/14_feature/scene_change_transition/transition_blast.atlas',
                    },
                    // hold and spin transition before win animation
                    {
                        alias: 'holdWinTransitionSkel',
                        src: 'assets/desktop/14_feature/bonus_collect_transition/bonus_collect_transition.skel',
                    },
                    {
                        alias: 'holdWinTransitionAtlas',
                        src: 'assets/desktop/14_feature/bonus_collect_transition/bonus_collect_transition.atlas',
                    },
                    // Reel frame reset transition
                    {
                        alias: 'reelFrameResetTransitionSkel',
                        src: 'assets/desktop/14_feature/scene_change_transition/stone_falling.skel',
                    },
                    {
                        alias: 'reelFrameResetTransitionAtlas',
                        src: 'assets/desktop/14_feature/scene_change_transition/stone_falling.atlas',
                    },
                    //symbols *********************
                    //hv1
                    {
                        alias: 'hv1Skel',
                        src: 'assets/desktop/12_symbols/hv1/hv_1.skel',
                    },
                    {
                        alias: 'hv1Atlas',
                        src: 'assets/desktop/12_symbols/hv1/hv_1.atlas',
                    },
                    {
                        alias: 'hv1Static',
                        src: 'assets/desktop/12_symbols/hv1/hv_1Static.webp',
                    },
                    {
                        alias: 'hv1Blur',
                        src: 'assets/desktop/12_symbols/hv1/hv_1Blur.webp',
                    },
                    //hv2
                    {
                        alias: 'hv2Skel',
                        src: 'assets/desktop/12_symbols/hv2/hv_2.skel',
                    },
                    {
                        alias: 'hv2Atlas',
                        src: 'assets/desktop/12_symbols/hv2/hv_2.atlas',
                    },
                    {
                        alias: 'hv2Static',
                        src: 'assets/desktop/12_symbols/hv2/hv_2Static.webp',
                    },
                    {
                        alias: 'hv2Blur',
                        src: 'assets/desktop/12_symbols/hv2/hv_2Blur.webp',
                    },
                    //hv3
                    {
                        alias: 'hv3Skel',
                        src: 'assets/desktop/12_symbols/hv3/hv_3.skel',
                    },
                    {
                        alias: 'hv3Atlas',
                        src: 'assets/desktop/12_symbols/hv3/hv_3.atlas',
                    },
                    {
                        alias: 'hv3Static',
                        src: 'assets/desktop/12_symbols/hv3/hv_3Static.webp',
                    },
                    {
                        alias: 'hv3Blur',
                        src: 'assets/desktop/12_symbols/hv3/hv_3Blur.webp',
                    },
                    //hv4
                    {
                        alias: 'hv4Skel',
                        src: 'assets/desktop/12_symbols/hv4/hv_4.skel',
                    },
                    {
                        alias: 'hv4Atlas',
                        src: 'assets/desktop/12_symbols/hv4/hv_4.atlas',
                    },
                    {
                        alias: 'hv4Static',
                        src: 'assets/desktop/12_symbols/hv4/hv_4Static.webp',
                    },
                    {
                        alias: 'hv4Blur',
                        src: 'assets/desktop/12_symbols/hv4/hv_4Blur.webp',
                    },
                    //hv5
                    {
                        alias: 'hv5Skel',
                        src: 'assets/desktop/12_symbols/hv5/hv_5.skel',
                    },
                    {
                        alias: 'hv5Atlas',
                        src: 'assets/desktop/12_symbols/hv5/hv_5.atlas',
                    },
                    {
                        alias: 'hv5Static',
                        src: 'assets/desktop/12_symbols/hv5/hv_5Static.webp',
                    },
                    {
                        alias: 'hv5Blur',
                        src: 'assets/desktop/12_symbols/hv5/hv_5Blur.webp',
                    },
                    //lv1
                    {
                        alias: 'lv1Skel',
                        src: 'assets/desktop/12_symbols/lv1/lv_1.skel',
                    },
                    {
                        alias: 'lv1Atlas',
                        src: 'assets/desktop/12_symbols/lv1/lv_1.atlas',
                    },
                    {
                        alias: 'lv1Static',
                        src: 'assets/desktop/12_symbols/lv1/lv_1Static.webp',
                    },
                    {
                        alias: 'lv1Blur',
                        src: 'assets/desktop/12_symbols/lv1/lv_1Blur.webp',
                    },
                    //lv2
                    {
                        alias: 'lv2Skel',
                        src: 'assets/desktop/12_symbols/lv2/lv_2.skel',
                    },
                    {
                        alias: 'lv2Atlas',
                        src: 'assets/desktop/12_symbols/lv2/lv_2.atlas',
                    },
                    {
                        alias: 'lv2Static',
                        src: 'assets/desktop/12_symbols/lv2/lv_2Static.webp',
                    },
                    {
                        alias: 'lv2Blur',
                        src: 'assets/desktop/12_symbols/lv2/lv_2Blur.webp',
                    },
                    //lv3
                    {
                        alias: 'lv3Skel',
                        src: 'assets/desktop/12_symbols/lv3/lv_3.skel',
                    },
                    {
                        alias: 'lv3Atlas',
                        src: 'assets/desktop/12_symbols/lv3/lv_3.atlas',
                    },
                    {
                        alias: 'lv3Static',
                        src: 'assets/desktop/12_symbols/lv3/lv_3Static.webp',
                    },
                    {
                        alias: 'lv3Blur',
                        src: 'assets/desktop/12_symbols/lv3/lv_3Blur.webp',
                    },
                    //lv4
                    {
                        alias: 'lv4Skel',
                        src: 'assets/desktop/12_symbols/lv4/lv_4.skel',
                    },
                    {
                        alias: 'lv4Atlas',
                        src: 'assets/desktop/12_symbols/lv4/lv_4.atlas',
                    },
                    {
                        alias: 'lv4Static',
                        src: 'assets/desktop/12_symbols/lv4/lv_4Static.webp',
                    },
                    {
                        alias: 'lv4Blur',
                        src: 'assets/desktop/12_symbols/lv4/lv_4Blur.webp',
                    },
                    //lv5
                    {
                        alias: 'lv5Skel',
                        src: 'assets/desktop/12_symbols/lv5/lv_5.skel',
                    },
                    {
                        alias: 'lv5Atlas',
                        src: 'assets/desktop/12_symbols/lv5/lv_5.atlas',
                    },
                    {
                        alias: 'lv5Static',
                        src: 'assets/desktop/12_symbols/lv5/lv_5Static.webp',
                    },
                    {
                        alias: 'lv5Blur',
                        src: 'assets/desktop/12_symbols/lv5/lv_5Blur.webp',
                    },
                    // lv6
                    {
                        alias: 'lv6Skel',
                        src: 'assets/desktop/12_symbols/lv6/lv_6.skel',
                    },
                    {
                        alias: 'lv6Atlas',
                        src: 'assets/desktop/12_symbols/lv6/lv_6.atlas',
                    },
                    {
                        alias: 'lv6Static',
                        src: 'assets/desktop/12_symbols/lv6/lv_6Static.webp',
                    },
                    {
                        alias: 'lv6Blur',
                        src: 'assets/desktop/12_symbols/lv6/lv_6Blur.webp',
                    },
                    //scatter
                    {
                        alias: 'scatterSkel',
                        src: 'assets/desktop/12_symbols/scatter/scatter.skel',
                    },
                    {
                        alias: 'scatterAtlas',
                        src: 'assets/desktop/12_symbols/scatter/scatter.atlas',
                    },
                    {
                        alias: 'scatterStatic',
                        src: 'assets/desktop/12_symbols/scatter/scatterStatic.webp',
                    },
                    {
                        alias: 'scatterBlur',
                        src: 'assets/desktop/12_symbols/scatter/scatterBlur.webp',
                    },
                    //silver wild
                    {
                        alias: 'wildSilverSkel',
                        src: 'assets/desktop/12_symbols/wild/wild_silver/wild_silver.skel',
                    },
                    {
                        alias: 'wildSilverAtlas',
                        src: 'assets/desktop/12_symbols/wild/wild_silver/wild_silver.atlas',
                    },
                    {
                        alias: 'wildSilverStatic',
                        src: 'assets/desktop/12_symbols/wild/wild_silver/wild_silverStatic.webp',
                    },
                    {
                        alias: 'wildSilverBlur',
                        src: 'assets/desktop/12_symbols/wild/wild_silver/wild_silverBlur.webp',
                    },
                    //gold wild
                    {
                        alias: 'wildGoldSkel',
                        src: 'assets/desktop/12_symbols/wild/wild_gold/wild_gold.skel',
                    },
                    {
                        alias: 'wildGoldAtlas',
                        src: 'assets/desktop/12_symbols/wild/wild_gold/wild_gold.atlas',
                    },
                    {
                        alias: 'wildGoldStatic',
                        src: 'assets/desktop/12_symbols/wild/wild_gold/wild_goldStatic.webp',
                    },
                    {
                        alias: 'wildGoldBlur',
                        src: 'assets/desktop/12_symbols/wild/wild_gold/wild_goldBlur.webp',
                    },
                    //special_coin
                    {
                        alias: 'specialSymbolSkel',
                        src: 'assets/desktop/12_symbols/special_coin/gold/special_coin_gold.skel',
                    },
                    {
                        alias: 'specialSymbolAtlas',
                        src: 'assets/desktop/12_symbols/special_coin/gold/special_coin_gold.atlas',
                    },
                    {
                        alias: 'specialSymbolStatic',
                        src: 'assets/desktop/12_symbols/special_coin/gold/special_coin_goldStatic.webp',
                    },
                    {
                        alias: 'specialSymbolBlur',
                        src: 'assets/desktop/12_symbols/special_coin/gold/special_coin_goldBlur.webp',
                    },
                    // grand
                    {
                        alias: 'grandSkel',
                        src: 'assets/desktop/12_symbols/special_coin/grand/special_coin_grand.skel',
                    },
                    {
                        alias: 'grandAtlas',
                        src: 'assets/desktop/12_symbols/special_coin/grand/special_coin_grand.atlas',
                    },
                    {
                        alias: 'grandStatic',
                        src: 'assets/desktop/12_symbols/special_coin/grand/special_coin_grandStatic.webp',
                    },
                    {
                        alias: 'grandBlur',
                        src: 'assets/desktop/12_symbols/special_coin/grand/special_coin_grandBlur.webp',
                    },
                    // major
                    {
                        alias: 'majorSkel',
                        src: 'assets/desktop/12_symbols/special_coin/major/special_coin_major.skel',
                    },
                    {
                        alias: 'majorAtlas',
                        src: 'assets/desktop/12_symbols/special_coin/major/special_coin_major.atlas',
                    },
                    {
                        alias: 'majorStatic',
                        src: 'assets/desktop/12_symbols/special_coin/major/special_coin_majorStatic.webp',
                    },
                    {
                        alias: 'majorBlur',
                        src: 'assets/desktop/12_symbols/special_coin/major/special_coin_majorBlur.webp',
                    },
                    // minor
                    {
                        alias: 'minorSkel',
                        src: 'assets/desktop/12_symbols/special_coin/minor/special_coin_minor.skel',
                    },
                    {
                        alias: 'minorAtlas',
                        src: 'assets/desktop/12_symbols/special_coin/minor/special_coin_minor.atlas',
                    },
                    {
                        alias: 'minorStatic',
                        src: 'assets/desktop/12_symbols/special_coin/minor/special_coin_minorStatic.webp',
                    },
                    {
                        alias: 'minorBlur',
                        src: 'assets/desktop/12_symbols/special_coin/minor/special_coin_minorBlur.webp',
                    },
                    // mini
                    {
                        alias: 'miniSkel',
                        src: 'assets/desktop/12_symbols/special_coin/mini/special_coin_mini.skel',
                    },
                    {
                        alias: 'miniAtlas',
                        src: 'assets/desktop/12_symbols/special_coin/mini/special_coin_mini.atlas',
                    },
                    {
                        alias: 'miniStatic',
                        src: 'assets/desktop/12_symbols/special_coin/mini/special_coin_miniStatic.webp',
                    },
                    {
                        alias: 'miniBlur',
                        src: 'assets/desktop/12_symbols/special_coin/mini/special_coin_miniBlur.webp',
                    },
                    {
                        alias: 'blankSymbol',
                        src: 'assets/desktop/12_symbols/blank/stone_base.webp',
                    },
                    // {
                    //     alias: 'goldStatic_HNW',
                    //     src: 'assets/desktop/12_symbols/special_coin/gold/special_coin_goldStatic_HNW.webp',
                    // },
                    // {
                    //     alias: 'grandStatic_HNW',
                    //     src: 'assets/desktop/12_symbols/special_coin/grand/special_coin_grandStatic_HNW.webp',
                    // },
                    // {
                    //     alias: 'majorStatic_HNW',
                    //     src: 'assets/desktop/12_symbols/special_coin/major/special_coin_majorStatic_HNW.webp',
                    // },
                    // {
                    //     alias: 'minorStatic_HNW',
                    //     src: 'assets/desktop/12_symbols/special_coin/minor/special_coin_minorStatic_HNW.webp',
                    // },
                    // {
                    //     alias: 'miniStatic_HNW',
                    //     src: 'assets/desktop/12_symbols/special_coin/mini/special_coin_miniStatic_HNW.webp',
                    // },
                    // // paylines animation
                    // {
                    //     alias: 'winLineSkel',
                    //     src: 'assets/desktop/payline/paylines.skel',
                    // },
                    // {
                    //     alias: 'winLineAtlas',
                    //     src: 'assets/desktop/payline/paylines.atlas',
                    // },
                    // Hold & Win Text animation
                    {
                        alias: 'holdWinTextSkel',
                        src: 'assets/desktop/14_feature/holdNwin_text/hold_&_win_text.skel',
                    },
                    {
                        alias: 'holdWinTextAtlas',
                        src: 'assets/desktop/14_feature/holdNwin_text/hold_&_win_text.atlas',
                    },
                    // anticipation animation
                    {
                        alias: 'anticipationSkel',
                        src: 'assets/desktop/anticipation/anticipation_2.skel',
                    },
                    {
                        alias: 'anticipationAtlas',
                        src: 'assets/desktop/anticipation/anticipation_2.atlas',
                    },
                    // drill anticipation animation
                    {
                        alias: 'wildAnticipationSkel',
                        src: 'assets/desktop/wildAnticipation/anticipation.skel',
                    },
                    {
                        alias: 'wildAnticipationAtlas',
                        src: 'assets/desktop/wildAnticipation/anticipation.atlas',
                    },
                    // Witch over the coin font
                    {
                        alias: 'germania one',
                        src: 'assets/desktop/11_font/germania-one/GermaniaOne-Regular.ttf',
                    },
                    {
                        alias: 'dtt_coin_font',
                        src: 'assets/desktop/11_font/dtt_font/digit.xml',
                    },
                    {
                        alias: 'coin_multiplier_font',
                        src: 'assets/desktop/11_font/dtt_font/coin_multiplier.xml',
                    },
                    {
                        alias: 'coin_font',
                        src: 'assets/desktop/11_font/coin_font/coin_font.xml',
                    },

                ],
            },
            {
                name: 'sound',
                assets: [
                    {
                        alias: 'bet-level',
                        src: 'assets/desktop/13_sound/ui/betlevel.mp3',
                    },
                    {
                        alias: 'click',
                        src: 'assets/desktop/13_sound/ui/btn_spin.mp3',
                    },
                    {
                        alias: 'base_music_ambient',
                        src: 'assets/desktop/13_sound/base/Bg_ambient.mp3',
                    },
                    {
                        alias: 'base_music_loop',
                        src: 'assets/desktop/13_sound/base/Bg_loop.mp3',
                    },
                    {
                        alias: 'transition_sound',
                        src: 'assets/desktop/13_sound/freegame/tremor_ending.mp3',
                    },
                    // {
                    //     alias: 'wolf_character_movinghandacross_knife',
                    //     src: 'assets/desktop/13_sound/base/wolf_character_movinghandacross_knife.mp3',
                    // },
                    // {
                    //     alias: 'wolf_character_animation3_licking',
                    //     src: 'assets/desktop/13_sound/base/wolf_character_animation3_licking.mp3',
                    // },
                    // {
                    //     alias: 'wolf_character_animation4_redeyes',
                    //     src: 'assets/desktop/13_sound/base/wolf_character_animation4_redeyes.mp3',
                    // },
                    // {
                    //     alias: 'wolf_character_animation5_flicksknife',
                    //     src: 'assets/desktop/13_sound/base/wolf_character_animation5_flicksknife.mp3',
                    // },
                    // {
                    //     alias: 'bonus_meter_refill',
                    //     src: 'assets/desktop/13_sound/freegame/bonus_meter_refill.mp3',
                    // },
                    {
                        alias: 'free_background_loop',
                        src: 'assets/desktop/13_sound/freegame/Fg_Loop.mp3',
                    },
                    {
                        alias: 'free_Game_Banner',
                        src: 'assets/desktop/13_sound/freegame/free_Game_Banner.mp3',
                    },
                    {
                        alias: 'total_win',
                        src: 'assets/desktop/13_sound/freegame/total_win.mp3',
                    },
                    {
                        alias: 'Scatter_Trigger',
                        src: 'assets/desktop/13_sound/freegame/scatter_trigger.mp3',
                    },
                    {
                        alias: 'Intro_transition',
                        src: 'assets/desktop/13_sound/gameloading/Intro_transition.mp3',
                    },
                    // {
                    //     alias: 'Intro_transition_chessse_explosion',
                    //     src: 'assets/desktop/13_sound/gameloading/Intro_cheese_explosion.mp3',
                    // },
                    // {
                    //     alias: 'multiplier_added_to_meter',
                    //     src: 'assets/desktop/13_sound/spin/multiplier_added_to_meter.mp3',
                    // },
                    // {
                    //     alias: 'multiplier_appearing_on_wild',
                    //     src: 'assets/desktop/13_sound/spin/multiplier_appearing_on_wild.mp3',
                    // },
                    {
                        alias: 'reel_stop',
                        src: 'assets/desktop/13_sound/spin/reel_stop.mp3',
                    },
                    {
                        alias: 'reels_spinning',
                        src: 'assets/desktop/13_sound/spin/reels_spinning.mp3',
                    },
                    {
                        alias: 'wild_flashing',
                        src: 'assets/desktop/13_sound/spin/wild_flashing.mp3',
                    },
                    {
                        alias: 'bonus_effect_adding_to_meter',
                        src: 'assets/desktop/13_sound/spin/bonus_effect_adding_to_meter.mp3',
                    },
                    {
                        alias: 'scatter_land',
                        src: 'assets/desktop/13_sound/others/scatter_landing.mp3',
                    },
                    {
                        alias: 'scatter_anticipation_loop',
                        src: 'assets/desktop/13_sound/spin/scatter_reel_loop.mp3',
                    },
                    // {
                    //     alias: 'throughthefire_symbol_activation',
                    //     src: 'assets/desktop/13_sound/spin/throughthefire_symbol_activation.mp3',
                    // },
                    {
                        alias: 'symbol_win',
                        src: 'assets/desktop/13_sound/win/common_win.mp3',
                    },
                    {
                        alias: 'symbol_win_multiply',
                        src: 'assets/desktop/13_sound/win/higher_win.mp3',
                    },
                    // {
                    //     alias: 'wild_sound_effect',
                    //     src: 'assets/desktop/13_sound/win/wild_sound_effect.mp3',
                    // },
                    {
                        alias: 'win_loop',
                        src: 'assets/desktop/13_sound/bigwin/Win_Loop.mp3',
                    },
                    // fight sequence sound effects
                    // {
                    //     alias: 'lady_killing_the_wolf_gunshot',
                    //     src: 'assets/desktop/13_sound/fight/lady_killing_the_wolf_gunshot.mp3',
                    // },
                    // {
                    //     alias: 'lady_killing_the_wolf_shout_effect',
                    //     src: 'assets/desktop/13_sound/fight/lady_killing_the_wolf_shout_effect.mp3',
                    // },
                    // {
                    //     alias: 'man_killing_the_wolf_gunshot',
                    //     src: 'assets/desktop/13_sound/fight/man_killing_the_wolf_gunshot.mp3',
                    // },
                    // {
                    //     alias: 'man_killing_the_wolf_shout_effect',
                    //     src: 'assets/desktop/13_sound/fight/man_killing_the_wolf_shout_effect.mp3',
                    // },
                    // {
                    //     alias: 'wolf_killing_man_lady_effect',
                    //     src: 'assets/desktop/13_sound/fight/wolf_killing_man_lady_effect.mp3',
                    // },
                    // {
                    //     alias: 'wolf_killing_the_lady_shout_effect',
                    //     src: 'assets/desktop/13_sound/fight/wolf_killing_the_lady_shout_effect.mp3',
                    // },
                    // {
                    //     alias: 'wolf_killing_the_man_shout_effect',
                    //     src: 'assets/desktop/13_sound/fight/wolf_killing_the_man_shout_effect.mp3',
                    // },
                    // {
                    //     alias: 'Win_Tear_Impact',
                    //     src: 'assets/desktop/13_sound/bigwin/Win_Tear_Impact.mp3',
                    // },
                    //Character Animations sound
                    // {
                    //     alias: 'character_licking_sound',
                    //     src: 'assets/desktop/13_sound/character/animation1.mp3',
                    // },
                    // {
                    //     alias: 'character_jumping_sound',
                    //     src: 'assets/desktop/13_sound/character/animation2.mp3',
                    // },
                    // {
                    //     alias: 'character_guiter_playing_sound',
                    //     src: 'assets/desktop/13_sound/character/animation3.mp3',
                    // },
                    // Mice Showing
                    // {
                    //     alias: 'mice_showing_sound',
                    //     src: 'assets/desktop/13_sound/character/mice_showing.mp3',
                    // },
                    // {
                    //     alias: 'wild_expand_and_slap',
                    //     src: 'assets/desktop/13_sound/character/wild_expanding.mp3',
                    // },
                    // {
                    //     alias: 'multiplier_hit_on_cheese',
                    //     src: 'assets/desktop/13_sound/character/multiplier_panel.mp3',
                    // },
                    // Cat throwing Coins
                    {
                        alias: 'cat_throwing_coins_sound',
                        src: 'assets/desktop/13_sound/character/cat_throwing_coins.mp3',
                    },
                    {
                        alias: 'Big_Win_Transition',
                        src: 'assets/desktop/13_sound/bigwin/Big_Win_Transition.mp3',
                    },
                    {
                        alias: 'Mega_Win_Transition',
                        src: 'assets/desktop/13_sound/bigwin/Mega_Win_Transition.mp3',
                    },
                    {
                        alias: 'Super_Win_Transition',
                        src: 'assets/desktop/13_sound/bigwin/Super_Win_Transition.mp3',
                    },
                    {
                        alias: 'Epic_Win_Transition',
                        src: 'assets/desktop/13_sound/bigwin/Epic_Win_Transition.mp3',
                    },
                    {
                        alias: 'win_tickup',
                        src: 'assets/desktop/13_sound/bigwin/Win_Count_up.mp3',
                    },
                    {
                        alias: 'win_tickup_end',
                        src: 'assets/desktop/13_sound/bigwin/Win_Count_up_End.mp3',
                    },
                    {
                        alias: 'wild_land',
                        src: 'assets/desktop/13_sound/others/wild.mp3',
                    },
                    {
                        alias: 'coin_multiplier',
                        src: 'assets/desktop/13_sound/others/coin_multiplier.mp3',
                    },
                    {
                        alias: 'character_sound',
                        src: 'assets/desktop/13_sound/character/character_sound_when_stretching.mp3',
                    },
                    {
                        alias: 'dynamite_blast',
                        src: 'assets/desktop/13_sound/others/dynamite_blast.mp3',
                    },
                    {
                        alias: 'hold_and_win',
                        src: 'assets/desktop/13_sound/others/hold_and_win.mp3',
                    },
                    {
                        alias: 'multiplier_panel',
                        src: 'assets/desktop/13_sound/others/multiplier_panel.mp3',
                    },
                    {
                        alias: 'golden_drill_anticipation',
                        src: 'assets/desktop/13_sound/others/right_reel_flashing.mp3',
                    },
                ],
            },

        ],
    }
};

